import { memo } from "react";
import { IonPage } from "@ionic/react";
import LoginOTPContent from "./layout/LoginOTPContent";
import useLoginOTPProvider from "./hooks/provider";

import s from "./LoginOTP.module.scss";

const LoginOTP: React.FC = (): JSX.Element => {
  useLoginOTPProvider();

  return (
    <IonPage className={s.loginOtpPage}>
      <LoginOTPContent />
    </IonPage>
  );
};

export default memo(LoginOTP);
